interface CurrencyFormatter {
  loc: string;
  currencies: Record<string, any>;
}

let formatter: CurrencyFormatter | null = null;

export default function (value: any, currency: any) {
  if (!value || !currency) {
    return value;
  }
  const parsedValue = parseFloat(value);
  if (isNaN(parsedValue)) {
    return value;
  }
  // const loc = store.state.localization.currentLocale;
  const loc = 'en';

  if (!formatter || formatter.loc != loc) {
    formatter = { loc, currencies: {} };
  }
  if (!formatter.currencies[currency]) {
    formatter.currencies[currency] = new Intl.NumberFormat(loc, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
    });
  }

  return formatter.currencies[currency].format(value).replace(/\s/g, '');
}
